/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';
import type { UnaccentTextSearch } from './UnaccentTextSearch';
import {
    UnaccentTextSearchFromJSON,
    UnaccentTextSearchFromJSONTyped,
    UnaccentTextSearchToJSON,
} from './UnaccentTextSearch';

/**
 * 
 * @export
 * @interface ServiceTutelleSearch
 */
export interface ServiceTutelleSearch {
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof ServiceTutelleSearch
     */
    nom?: UnaccentTextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ServiceTutelleSearch
     */
    code?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ServiceTutelleSearch
     */
    codePostal?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof ServiceTutelleSearch
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceTutelleSearch
     */
    actifManual?: boolean | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ServiceTutelleSearch
     */
    selectedIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ServiceTutelleSearch
     */
    availableIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServiceTutelleSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ServiceTutelleSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ServiceTutelleSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServiceTutelleSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ServiceTutelleSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceTutelleSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ServiceTutelleSearch interface.
 */
export function instanceOfServiceTutelleSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ServiceTutelleSearchFromJSON(json: any): ServiceTutelleSearch {
    return ServiceTutelleSearchFromJSONTyped(json, false);
}

export function ServiceTutelleSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceTutelleSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom': !exists(json, 'nom') ? undefined : UnaccentTextSearchFromJSON(json['nom']),
        'code': !exists(json, 'code') ? undefined : TextSearchFromJSON(json['code']),
        'codePostal': !exists(json, 'codePostal') ? undefined : TextSearchFromJSON(json['codePostal']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'actifManual': !exists(json, 'actifManual') ? undefined : json['actifManual'],
        'selectedIds': !exists(json, 'selectedIds') ? undefined : json['selectedIds'],
        'availableIds': !exists(json, 'availableIds') ? undefined : json['availableIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ServiceTutelleSearchToJSON(value?: ServiceTutelleSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom': UnaccentTextSearchToJSON(value.nom),
        'code': TextSearchToJSON(value.code),
        'codePostal': TextSearchToJSON(value.codePostal),
        'actif': BooleanSearchToJSON(value.actif),
        'actifManual': value.actifManual,
        'selectedIds': value.selectedIds,
        'availableIds': value.availableIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

